import AuthRepository from 'src/api/repositories/common/v1/auth.repository';

const ORIGIN = 'ESS';

export const useGetLegacyUrl = () => {
  const [trigger, result] = AuthRepository.endpoints.useLazyInitiateAgileSSOQuery();

  const fetchLegacyUrl = async (): Promise<string | undefined> => {
    const res = await trigger({ origin: ORIGIN }).unwrap();
    return res?.legacyUrl;
  };

  const getLegacyUrlAsync = async (): Promise<string | undefined> => {
    const legacyUrl = await fetchLegacyUrl();
    if (!legacyUrl) return;

    return legacyUrl;
  };

  const redirectToLegacyApp = async () => {
    const url = await getLegacyUrlAsync();

    if (!url) return;

    window.location.replace(url);
  };

  return {
    getLegacyUrlAsync,
    redirectToLegacyApp,
    loading: result.isLoading,
    error: result.error,
  };
};
